<template>
  <v-dialog v-model="dialog" persistent eager max-width="400">
    <v-card-title class="navy darken-1 white--text">
      <div v-if="isAdminSet">
        <v-icon class="white--text" left>edit</v-icon>
        Cambia amministratore asta
      </div>
      <div v-else>Imposta amministratore asta</div>
      <v-spacer></v-spacer>
      <v-btn depressed class="white--text" light icon @click="dismiss">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-sheet class="white" style="height: 400px; overflow-y: auto">
      <div class="pa-4">
        <div class="navy--text">
          <span v-if="!isAdminSet"
            >Prima di iniziare si deve impostare una squadra che agirà da
            amministratore d'asta.</span
          >
          L'amministratore d'asta è l'unica persona che può cambiare le
          impostazioni, far partire o fermare l'asta etc...<br /><br />
          <v-icon small class="navy--text">info</v-icon> Non deve essere per
          forza l'amministratore di lega/divisione.<br />
          <v-icon small class="navy--text">info</v-icon> L'amministratore d'asta
          potrà assegnare tale ruolo a un'altra squadra in qualunque momento
          (utile se ha completato la rosa e vuole abbandonare l'asta)
        </div>
        <div>
          <v-icon small class="error--text">warning</v-icon>
          <span class="error--text">
            L'amministratore d'asta deve rimanere <b>SEMPRE ONLINE</b> o Asta
            Live si bloccherà.</span
          >
          Può essere anche "temporaneamente escluso" dall'asta se serve (se ha
          terminato la rosa ad esempio) ma deve comunque rimanere online.
        </div>
      </div>
      <v-list dense nav v-if="asta_squadre_array.length > 0">
        <div class="lista">
          <v-list-item
            v-for="sq in asta_squadre_array"
            :key="sq.id"
            :disabled="squadraDisabled(sq.id)"
            @click="change(sq.id)"
          >
            <v-list-item-avatar>
              <img :src="squadra(sq.id).pic" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title
                ><span class="stato mx-2" :class="squadraPresenceClass(sq.id)"></span
                >{{ sq.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
      <div v-else class="text-center pa-4">
        <div>
          Nessuna squadra a cui poter assegnare il ruolo di Amministratore
          d'asta.
        </div>
        <v-btn rounded small outlined @click="checkAllineamentoRose(true)">
          Check allineamento squadre
        </v-btn>
      </div>
    </v-sheet>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import Vuex from "vuex";

export default {
  name: "asta-change-admin",
  mixins: [mixins, toast],
  components: {},
  data() {
    return {
      dialog: false,
    };
  },

  mounted() {
    console.log("--> AstaChangeAdmin ready.");
    db.on("promptChangeAdmin", this.show);
  },

  destroyed() {
    console.log("<-- AstaChangeAdmin destroyed.");
    db.off("promptChangeAdmin", this.show);
  },

  methods: {
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
    squadraDisabled(squadra_id) {
      return this.adminUid == squadra_id;
    },
    squadraPresenceClass(squadra_id) {
      const presence = this.asta_online[squadra_id];
      return this.getPresenceClass(presence);
    },
    change(uid) {
      // eccezionalmente se nn c'è l'admin può impostarlo una squadra qualunque
      // se nn c'è un admin impostato può solo una delle squadre
      if (!this.isAdminSet && !this.my_squadra) {
        Swal.fire({
          icon: "error",
          title: "Attenzione",
          text: "L'amministratore è impostabile solo da una delle squadre partecipanti all'asta",
          confirmButtonText: "Ok, ho capito",
        });
        return;
      }

      // se c'è un admin impostato, può solo lui
      if (this.isAdminSet && !this.admin) {
        db.emit("swalAdmin");
        return;
      }

      // asta non in corso
      if (this.isAstaInCorso) {
        db.emit(
          "swalAstaInCorso",
          "E' possibile modificare amministratore solo dopo aver fermato l'asta"
        );
      }

      Swal.fire({
        title: "Confermi? ",
        text: "Dopo aver confermato, solo la persona appena scelta potrà ricambiare l'amministratore d'asta.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed == true) {
          db.updateAdmin(uid)
            .then(() => {
              this.dismiss();
              this.successToast("Amministratore modificato", "");
            })
            .catch(() => {
              this.errorToast("Amministratore non modificato", "");
            });
        }
      });
    },
  },
  computed: {
    ...Vuex.mapGetters(["asta_squadre_array"]),
  },
};
</script>
<style lang="scss" scoped>
</style>
